import dayjs from "dayjs";
import { FaEye } from "react-icons/fa";
import { addMinIcon, editgray } from "../tabsvgs";
import { useState } from "react";
import AddTimeEntryModal from "./modals/addTimeEntryModal";

const CarePlanTable = ({
  tableData,
  settype,
  auditData,
  setSelectedRecord,
  selectedRecord,
  loading,
  onView,
  fetchAuditData,
  lock,
   showAddModal,
setShowAddModal,
insertAuditData,
}) => {


  return (
    <div className="w-full flex justify-center">
      <div className="w-[80%] max-h-[400px] overflow-y-auto overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
        <table className="w-full border-collapse">
          <thead className="sticky top-0 bg-[#5D8CA3] text-white">
            <tr>
              <th className="py-3 pl-6 text-[13px] font-medium text-center font-inter">
                DATE & TIME
              </th>
              <th className="py-3 px-6 text-[13px] font-medium text-center font-inter">
                STATUS
              </th>
              <th className="py-3 px-6 text-[13px] font-medium text-center font-inter">
                DURATION
              </th>
              <th className="py-3 px-6 text-[13px] font-medium text-center font-inter">
                ACTIONS
              </th>
            </tr>
          </thead>

          <tbody>
            {lock ? (
              <div
                // colSpan={4}
                className="text-center py-24 text-gray-500 text-sm"
              >
                {/* {loading ? "Getting Data ....." : "No records found"} */}
              </div>
            ) : tableData.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className="text-center py-6 text-gray-500 text-sm"
                >
                  {loading ? "Getting Data ....." : "No records found"}
                </td>
              </tr>
            ) : (
              tableData.map((row, index) => (
                <tr
                  key={index}
                  className={`border-b ${
                    index % 2 === 0 ? "bg-white" : "bg-[#F9FAFB]"
                  }`}
                >
                  <td className="py-3 pl-6 text-[13px] text-[#000000] text-center">
                    {dayjs(row.ts).format("MM/DD/YYYY HH:mm A")}
                  </td>
                  <td className="py-3 px-6 text-center">
                    <span
                      className={`px-3 py-1 text-[13px] font-inter font-normal rounded-full ${
                        row.status === "Completed"
                          ? "bg-[#DCFCE7] text-[#166534]"
                          : "bg-[#FEF9C3] text-[#854D0E]"
                      }`}
                    >
                      {row.status}
                    </span>
                  </td>
                  <td className="py-3 px-6 text-center">
                    <div className="flex gap-3 justify-center items-center">
                      <div className="text-[#000000] text-[14px] font-inter">
                       {row.duration}
                      </div>
                      <button
                        className="focus:outline-none cursor-pointer"
                        onClick={() => {
                           setSelectedRecord(row);
                          fetchAuditData(row.audiolink)}}
                      >
                        {addMinIcon}
                      </button>
                    </div>
                  </td>
                  <td className="py-3 px-6 text-center">
                    <div className="flex items-center justify-center gap-6 text-[14px] font-inter font-normal text-[#6A7282]">
                      <button
                        className={`flex items-center gap-1 ${
                          row.status === "Submitted"
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        onClick={() => {
                          if (row.status !== "Submitted") {
                            settype("view");
                            onView(row.audiolink);
                          }
                        }}
                        disabled={row.status === "Submitted"}
                      >
                        <FaEye size={14} /> View
                      </button>
                      <button
                        onClick={() => {
                          if (row.status !== "Submitted") {
                            setSelectedRecord(row);
                            settype("edit");
                            onView(row.audiolink);
                          }
                        }}
                        className={`flex items-center gap-1 ${
                          row.status === "Submitted"
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        {editgray} Edit
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <AddTimeEntryModal
        open={showAddModal}
        onClose={() => setShowAddModal(false)}
      auditData={auditData}
        selectedRecord={selectedRecord}
        insertAuditData={insertAuditData}
 
      />
    </div>
  );
};

export default CarePlanTable;
